var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.show)?_c('div',{staticClass:"menu"},[_c('ul',_vm._l((_vm.menuData),function(menu){return _c('li',{key:menu.id,on:{"click":function($event){return _vm.toMenuLink(menu)}}},[_vm._v(_vm._s(menu.name))])}),0)]):_c('div',{staticClass:"bannerMenu"},[_vm._v("手机菜单")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11cf4c80","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/menus.vue
// module id = null
// module chunks = 